import { modalRenderer } from '~/modal/modalRendererRegistry';
import { SubscriptionManagementContainer } from './subscriptionManagement.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    SubscriptionManagement: undefined;
  }
}

modalRenderer.register('SubscriptionManagement', SubscriptionManagementContainer);
